/**
 * @component PageBackgroundSetting
 * @description 页面名称与背景设置卡片组件，用于自定义装修页面中编辑页面名称和配置背景样式。
 * 当 diy_id 为 1 时显示页面名称编辑区域，始终显示背景设置入口按钮。
 *
 * @props {String} diy_id - 装修页面标识，值为 "1" 时显示页面名称编辑区域，默认 "0"
 * @props {String} title - 页面名称，用于展示和编辑回显，默认空字符串
 * @props {Object} backgroundData - 背景设置数据对象，点击设置按钮时传递给父组件，默认空对象
 *
 * @emits update-title - 确认编辑页面名称时触发，参数为新的页面名称 (string)
 * @emits update-value - 点击背景设置按钮时触发，参数为当前背景数据对象 (Object)
 */
<!-- 页面名称 背景设置 -->
<template>
    <div>
        <div class="card">
            <div class="flex-sb mb12" v-if="String(diy_id) === '1'">
                <span class="title mb0">页面名称</span>
                <span class="p" v-if="title">{{ title }}</span>
                <span class="span" v-else>页面的名称</span>
                <img
                    class="w20 cursor-p"
                    src="@/assets/diy_input.png"
                    role="button"
                    tabindex="0"
                    @click="goModal"
                    @keydown.enter="goModal"
                />
            </div>
            <div class="flex-sb">
                <div class="title">背景设置</div>
                <Button @click="clickDefault">设置</Button>
            </div>
        </div>
        <!-- 编辑页面 -->
        <Modal
            v-model="pageModal"
            title="编辑页面"
            width="500"
            :mask-closable="false"
        >
            <Form :model="formPage" label-position="right" :label-width="100">
                <FormItem label="页面名称">
                    <Input
                        class="w300"
                        v-model="formPage.title"
                        type="text"
                        placeholder="请输入页面名称"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    props: {
        diy_id: {
            type: [String, Number],
            default: "0",
        },
        title: {
            type: String,
            default: "",
        },
        backgroundData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            pageModal: false,
            formPage: {
                title: "",
            },
        };
    },
    methods: {
        goModal() {
            this.formPage.title = this.title;
            this.pageModal = true;
        },
        cancelModal() {
            this.formPage.title = "";
            this.pageModal = false;
        },
        submitModal() {
            if (!this.formPage.title) {
                this.$Message.error("请输入页面名称");
                return;
            }
            this.$emit("update-title", this.formPage.title);
            this.pageModal = false;
        },
        // 背景设置按钮
        clickDefault() {
            this.$emit("update-value", this.backgroundData);
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.p {
    width: 150px;
    font-size: 14px;
    color: #484e66;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.span {
    margin: 0 24px 0 12px;
    font-size: 14px;
    color: #bbb;
}
.title {
    font-weight: 400;
    font-size: 16px;
    color: #484e66;
    width: 64px;
    white-space: nowrap;
}
.w20 {
    width: 20px;
    height: 20px;
}
.cursor-p {
    cursor: pointer;
}
::v-deep .ivu-form-item {
    margin-bottom: 0;
}
</style>